var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57031 4.78162H7.2846V5.65328H2.57031V4.78162ZM2.57031 6.96078H8.14174V7.83244H2.57031V6.96078Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1429 0.423828H0.857143C0.629814 0.423828 0.411797 0.515665 0.251051 0.679135C0.0903058 0.842605 0 1.06432 0 1.2955V10.0122C0 10.2434 0.0903058 10.4651 0.251051 10.6286C0.411797 10.792 0.629814 10.8839 0.857143 10.8839H11.1429C11.3702 10.8839 11.5882 10.792 11.7489 10.6286C11.9097 10.4651 12 10.2434 12 10.0122V1.2955C12 1.06432 11.9097 0.842605 11.7489 0.679135C11.5882 0.515665 11.3702 0.423828 11.1429 0.423828ZM11.1429 1.2955V2.16717H0.857143V1.2955H11.1429ZM0.857143 10.0122V3.03884H11.1429V10.0122H0.857143Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.16227911.svg";
export { ForwardRef as ReactComponent };